import { patchAuthenticated } from '../../../../../services/RestTemplate';
import { alertsApi } from '../../list/redux/backend';

export function dismissAlert(alertId, reason, note) {
    const dismissAlertUrl = alertsApi + '/' + alertId;

    let data;
    if (reason || note) {
        data = {
            dismissType: reason,
            note: note
        };
    }

    return data
        ? patchAuthenticated(dismissAlertUrl, data)
        : patchAuthenticated(dismissAlertUrl);
}
